import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';

@Injectable({providedIn: 'root'})
export class RegistroTraspasoColeccionistaService {

    constructor(private apiService: ApiService) { }
    
    postRegistroTraspaso(body:any){
        const url= `/bien_cultural/traspaso` 
        return new Promise((resolve, reject)=>{
            this.apiService.PutMethod(url, body, {}, 'Error al Guardar Traspaso de Bien Mueble.')
                .subscribe(response => {
                    resolve(response)  
                }, error => {
                    reject(error)
                })
        })
    }

    getHistorialTraspaso(bienCulturalUuid:string) {
        const url= `/traspaso_bien/${bienCulturalUuid}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener historial de traspaso.')
                .subscribe((response:any) => {
                    resolve(response.data)  
                }, error => {
                    reject(error)
                })
        })
    }
}